var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-auto pa-5 d-flex flex-column"},[_c('h4',[_vm._v(_vm._s(_vm.$t('data_relations')))]),(_vm.loading)?_c('KpIcon',{attrs:{"icon-cls":"refresh ic-spin","color":"primary","size":"32"}}):_vm._e(),_c('DependencyView',{attrs:{"dependencies":_vm.dependencies,"single":"","full":"","message":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }